import { ClientOnly } from '@go-beyond/react'
import { ThemeProvider } from '@origens/ui/theme'
import type { ReactNode } from 'react'

export default function RootLayout({ children }: { children: ReactNode }) {
  return (
    <ClientOnly fallback={children}>
      <ThemeProvider>{children}</ThemeProvider>
    </ClientOnly>
  )
}
